import { NotificationLevel } from 'modules/settings/components/custom-notifications/custom-notification-threshold.model';

const THRESHOLDS_I18N_PREFIX = 'settings.custom-notifications.thresholds';

export const THRESHOLDS_TITLE_KEY = `${THRESHOLDS_I18N_PREFIX}.title`;

export const THRESHOLDS_HINT_KEY = `${THRESHOLDS_I18N_PREFIX}.hint`;

export const THRESHOLD_LABEL_KEYS: Record<NotificationLevel, string> = {
    gray: `${THRESHOLDS_I18N_PREFIX}.information`,
    yellow: `${THRESHOLDS_I18N_PREFIX}.warning`,
    red: `${THRESHOLDS_I18N_PREFIX}.alarm`,
};

export const THRESHOLD_OCCURRENCES_ARIA_KEY = `${THRESHOLDS_I18N_PREFIX}.occurrences-aria`;
